import Notification from 'bootstrap-italia/src/js/plugins/notification';

const NAME_UTIL = "KibernetesNotification";

export default class KibernetesNotification {
	#not;

	constructor( title='Titolo', msg='Errore', stato='error', svg='' ) {
		const x = document.getElementById( 'kiberNotif' );
		if ( x && x.parent ) {
			x.parent.removeChild( x );
		}
		const d = document.createElement("div");
		d.id = 'kiberNotif';
		d.classList.add( 'notification' );
		d.classList.add( 'right-fix' );
		d.classList.add( 'with-icon' );
		d.classList.add( 'dismissable' );
		d.classList.add( stato );
		d.role = 'alert';
		d.setAttribute( 'aria-labelledby', "not1d-title" );

		const t = this.#createTitle( title, svg );
		d.appendChild( t );

		const m = this.#createMessage( msg );
		d.appendChild( m );

		const b = this.#createCloseButton( svg );
		d.appendChild( b );
		b.addEventListener('click', (x) => {
			this.#not.hide();
		});

		const e = document.body.appendChild( d );
		this.#not = new Notification( e );
		this.#not.show();
	}
	#createTitle( title, svg ) {
		const t = document.createElement("h2");
		t.id = 'notTitle';
		t.classList.add( 'h5' );
		t.innerHTML = '<svg class="icon"><use xlink:href="' + svg + '#it-check-circle"></use></svg>' + title + '</h2>';
		return t;
	}
	#createMessage( msg ) {
		const p = document.createElement("p");
		p.innerHTML = msg;
		return p;
	}
	#createCloseButton( svg ) {
		const b = document.createElement("button");
		b.type = 'button';
		b.classList.add( 'btn' );
		b.classList.add( 'notification-close' );
		b.innerHTML = '<svg class="icon"><use xlink:href="' + svg + '#it-close"></use></svg><span class="visually-hidden">Chiudi notifica</span>';
		return b;
	}
}
